/**
 * 文本处理工具函数
 * 用于跟读模式的分句和阅读时间估算
 */

/**
 * 按英文标点分句，保留标点
 * 智能处理常见的句末标点：. ! ?
 */
export const splitSentences = (text: string): string[] => {
  if (!text || typeof text !== 'string') return [];
  
  // 清理文本：去除多余空格，标准化引号
  const cleanText = text
    .replace(/\s+/g, ' ')  // 多个空格转为单个
    .replace(/[""]/g, '"')  // 统一引号
    .replace(/['']/g, "'")   // 统一单引号
    .trim();
  
  if (!cleanText) return [];
  
  // 按句末标点分割，保留标点
  // 匹配：. 后面跟空格和大写字母、!、? 后面跟空格
  const sentences = cleanText
    .replace(/([.!?])(\s+)(?=[A-Z"'])/g, "$1|SPLIT|")  // 在句点后分割，保留大写开头或引号
    .split("|SPLIT|")
    .map(s => s.trim())
    .filter(s => s.length > 0);
  
  // 如果没有分出句子（可能缺少空格），返回整段
  if (sentences.length === 0) {
    return [cleanText];
  }
  
  return sentences;
};

/**
 * 估算每句阅读时间（儿童语速：每分钟60-80词）
 * @param sentence 句子文本
 * @returns 阅读时间（毫秒）
 */
export const estimateReadingTime = (sentence: string): number => {
  if (!sentence) return 3000;
  
  const wordCount = sentence.split(/\s+/).filter(w => w.length > 0).length;
  
  // 儿童阅读语速较慢：
  // - 基础时间：3秒
  // - 每词增加 0.8-1秒（根据词数动态调整）
  const baseTime = 3000; // 3秒基础时间
  const timePerWord = wordCount <= 3 ? 1000 : wordCount <= 6 ? 800 : 700;
  const additionalTime = wordCount * timePerWord;
  
  // 短句最少4秒，长句最多8秒
  const totalMs = Math.max(4000, Math.min(8000, baseTime + additionalTime));
  
  return totalMs;
};

/**
 * 计算文本的词数
 */
export const countWords = (text: string): number => {
  if (!text) return 0;
  return text.trim().split(/\s+/).filter(w => w.length > 0).length;
};

/**
 * 格式化阅读进度
 */
export const formatProgress = (current: number, total: number): string => {
  return `${current + 1} / ${total}`;
};
